"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ACTIVATION_CHECK_CODES () {
        return ACTIVATION_CHECK_CODES;
    },
    get ActivationChecksResponseSchema () {
        return ActivationChecksResponseSchema;
    },
    get ActivationChecksSchema () {
        return ActivationChecksSchema;
    },
    get BleedTestResultSchema () {
        return BleedTestResultSchema;
    },
    get ChangeTenantStatusRequestSchema () {
        return ChangeTenantStatusRequestSchema;
    },
    get ChangeTenantStatusResponseSchema () {
        return ChangeTenantStatusResponseSchema;
    },
    get CreateTenantRequestSchema () {
        return CreateTenantRequestSchema;
    },
    get CreateTenantResponseSchema () {
        return CreateTenantResponseSchema;
    },
    get PLATFORM_TENANT_SLUG () {
        return PLATFORM_TENANT_SLUG;
    },
    get TENANT_KINDS () {
        return TENANT_KINDS;
    },
    get TENANT_LIFECYCLE_ERROR_CODES () {
        return TENANT_LIFECYCLE_ERROR_CODES;
    },
    get TENANT_NAME_MAX_LENGTH () {
        return TENANT_NAME_MAX_LENGTH;
    },
    get TENANT_SLUG_MAX_LENGTH () {
        return TENANT_SLUG_MAX_LENGTH;
    },
    get TENANT_SLUG_MIN_LENGTH () {
        return TENANT_SLUG_MIN_LENGTH;
    },
    get TENANT_SLUG_PATTERN () {
        return TENANT_SLUG_PATTERN;
    },
    get TENANT_STATUSES () {
        return TENANT_STATUSES;
    },
    get TenantCountsSchema () {
        return TenantCountsSchema;
    },
    get TenantListResponseSchema () {
        return TenantListResponseSchema;
    },
    get TenantNameSchema () {
        return TenantNameSchema;
    },
    get TenantSlugSchema () {
        return TenantSlugSchema;
    },
    get TenantSummarySchema () {
        return TenantSummarySchema;
    }
});
const _zod = require("zod");
const _tenantaccess = require("../auth/tenant-access");
const TENANT_STATUSES = [
    'provisioning',
    'active',
    'suspended'
];
const TENANT_KINDS = [
    'platform',
    'clinic'
];
const PLATFORM_TENANT_SLUG = 'platform';
const TENANT_SLUG_PATTERN = /^[a-z0-9](-?[a-z0-9])*$/;
const TENANT_SLUG_MIN_LENGTH = 3;
const TENANT_SLUG_MAX_LENGTH = 63;
const TENANT_NAME_MAX_LENGTH = 200;
const TENANT_LIFECYCLE_ERROR_CODES = {
    /** The caller's own tenant is suspended. Every route but `/v1/auth/**` answers this. */ suspended: 'TENANT_SUSPENDED',
    /** Activation was refused. `errors[]` lists the failed checks. */ activationChecksFailed: 'ACTIVATION_CHECKS_FAILED',
    /** A live tenant already has this slug. */ slugTaken: 'TENANT_SLUG_TAKEN',
    /** The platform tenant is always active. */ platformStatusFixed: 'PLATFORM_TENANT_STATUS_FIXED'
};
const ACTIVATION_CHECK_CODES = [
    'idis2go_link',
    'emr_instance',
    'clinic_admin',
    'bleed_test'
];
const TenantSlugSchema = _zod.z.string().min(TENANT_SLUG_MIN_LENGTH).max(TENANT_SLUG_MAX_LENGTH).regex(TENANT_SLUG_PATTERN, 'slug must be lowercase letters and digits with single hyphens');
const TenantNameSchema = _zod.z.string().trim().min(1).max(TENANT_NAME_MAX_LENGTH);
const CreateTenantRequestSchema = _zod.z.object({
    name: TenantNameSchema,
    slug: TenantSlugSchema.refine((slug)=>slug !== PLATFORM_TENANT_SLUG, {
        message: 'the platform slug is reserved'
    }),
    kind: _zod.z.literal('clinic')
}).strict();
const TenantCountsSchema = _zod.z.object({
    emrInstances: _zod.z.object({
        active: _zod.z.number().int().nonnegative(),
        disabled: _zod.z.number().int().nonnegative(),
        lastSeenAt: _zod.z.iso.datetime().nullable()
    }).strict(),
    idis2goLinks: _zod.z.object({
        enabled: _zod.z.number().int().nonnegative(),
        disabled: _zod.z.number().int().nonnegative()
    }).strict(),
    resultFiles: _zod.z.object({
        waiting: _zod.z.number().int().nonnegative(),
        copied: _zod.z.number().int().nonnegative(),
        missing: _zod.z.number().int().nonnegative()
    }).strict(),
    results: _zod.z.object({
        pending: _zod.z.number().int().nonnegative(),
        available: _zod.z.number().int().nonnegative(),
        delivered: _zod.z.number().int().nonnegative(),
        failed: _zod.z.number().int().nonnegative()
    }).strict()
}).strict();
const TenantSummarySchema = _zod.z.object({
    id: _zod.z.uuid(),
    name: _zod.z.string(),
    slug: _zod.z.string(),
    kind: _zod.z.enum(TENANT_KINDS).nullable(),
    status: _zod.z.enum(TENANT_STATUSES),
    createdAt: _zod.z.iso.datetime(),
    updatedAt: _zod.z.iso.datetime(),
    counts: TenantCountsSchema
}).strict();
const TenantListResponseSchema = _zod.z.object({
    items: _zod.z.array(TenantSummarySchema)
}).strict();
const CreateTenantResponseSchema = _zod.z.object({
    tenant: TenantSummarySchema,
    accessGrant: _tenantaccess.AccessGrantCreatedResponseSchema.nullable()
}).strict();
const BleedTestResultSchema = _zod.z.object({
    passed: _zod.z.boolean(),
    tablesChecked: _zod.z.number().int().nonnegative(),
    failedTables: _zod.z.array(_zod.z.string())
}).strict();
const ActivationChecksSchema = _zod.z.object({
    passed: _zod.z.boolean(),
    idis2goLink: _zod.z.object({
        passed: _zod.z.boolean(),
        enabledLinks: _zod.z.number().int().nonnegative()
    }).strict(),
    emrInstance: _zod.z.object({
        passed: _zod.z.boolean(),
        checkedInInstances: _zod.z.number().int().nonnegative()
    }).strict(),
    clinicAdmin: _zod.z.object({
        passed: _zod.z.boolean(),
        adminsWithMfa: _zod.z.number().int().nonnegative()
    }).strict(),
    bleedTest: BleedTestResultSchema
}).strict();
const ActivationChecksResponseSchema = _zod.z.object({
    tenantId: _zod.z.uuid(),
    status: _zod.z.enum(TENANT_STATUSES),
    checks: ActivationChecksSchema
}).strict();
const ChangeTenantStatusRequestSchema = _zod.z.object({
    status: _zod.z.enum([
        'active',
        'suspended'
    ])
}).strict();
const ChangeTenantStatusResponseSchema = _zod.z.object({
    tenant: TenantSummarySchema
}).strict();
